import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import {
	BORDER_WIDTH,
	RACK_MATERIAL_COLORS,
	SIDES_DISTANCE,
} from '@/shared/constants/configurator';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import { calculateConfiguratorWidth } from '@/shared/lib/configurator';
import { calculateSectionLeftPositions } from '../../lib/styles';
import styles from './top-editor-sections-connection.module.css';

export const TopEditorSectionsConnection = () => {
	const {
		state: { sections, wallMounted, material },
	} = useConfigurator();

	const width = calculateConfiguratorWidth(sections, wallMounted);
	const leftPositions = calculateSectionLeftPositions(sections, wallMounted);

	return (
		<div
			className={styles.wrapper}
			style={{ width: width * DISPLAY_SCALE, height: SIDES_DISTANCE * DISPLAY_SCALE }}
		>
			{sections.map((section, index) => (
				<div
					style={{
						left: leftPositions[index],
						width: (section.width + BORDER_WIDTH * 2) * DISPLAY_SCALE,
						borderColor: RACK_MATERIAL_COLORS[material],
						borderLeftWidth: BORDER_WIDTH * DISPLAY_SCALE,
						borderRightWidth: BORDER_WIDTH * DISPLAY_SCALE,
					}}
					className={styles.section}
					key={index}
				/>
			))}
		</div>
	);
};
